const CicReasonFormModalTestIdsScope = {
  CIC_REASON_FORM: 'cic-reason-form',
};

export const CicReasonFormModalTestIds = {
  CIC_REASON_FORM_SELECT_A_REASON_INPUT: `${CicReasonFormModalTestIdsScope.CIC_REASON_FORM}.select-a-reason-input`,
  CIC_REASON_FORM_SELECT_A_REASON_OPTION: `${CicReasonFormModalTestIdsScope.CIC_REASON_FORM}.select-a-reason-option`,
  CIC_REASON_FORM_CANCEL_BUTTON: `${CicReasonFormModalTestIdsScope.CIC_REASON_FORM}.cancel-button`,
  CIC_REASON_FORM_SKIP_BUTTON: `${CicReasonFormModalTestIdsScope.CIC_REASON_FORM}.skip-button`,
  CIC_REASON_FORM_SAVE_BUTTON: `${CicReasonFormModalTestIdsScope.CIC_REASON_FORM}.save-button`,

  getNoteInputId: (feeTypeId, reasonId) =>
    `${CicReasonFormModalTestIdsScope.CIC_REASON_FORM}.note-${feeTypeId}-${reasonId}-input`,
  getTemplateSelectId: (feeTypeId, reasonId) =>
    `${CicReasonFormModalTestIdsScope.CIC_REASON_FORM}.template-${feeTypeId}-${reasonId}-select`,
  getTemplateSelectInputId: (feeTypeId, reasonId) =>
    `${CicReasonFormModalTestIdsScope.CIC_REASON_FORM}.template-${feeTypeId}-${reasonId}-select-input`,
  getTemplateSelectOptionId: (feeTypeId, reasonId) =>
    `${CicReasonFormModalTestIdsScope.CIC_REASON_FORM}.template-${feeTypeId}-${reasonId}-select-option`,
};
